module.exports = __webpack_public_path__ + "img/logo_helm.bf3d384d.png";